import React from "react";
import Layout from "../components/layout";
import AboutContent from "../components/aboutContent";


const IndexPage = () => {
    return ( 

        <Layout>
            
            <AboutContent/>
        </Layout>
     );
}
 
export default IndexPage;

